import React, { useState } from 'react';
import { Radio, Button, Input, Card, Flex, Space, Typography, message, Upload, Switch, ConfigProvider, Divider, Select } from 'antd';
import { EditOutlined, LoadingOutlined, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useLocation } from "react-router-dom";
import axios from "axios";
import streenTheme from "../../theme"

import StoryImage from "../StoryImage";

import { STORY_CATEGORIES, getCategory } from "../../config/storyCategories";


const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Du kannst nur JPG/PNG Dateien hochladen!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('das Bild muss kleiner als 2MB sein!!');
  }
  return isJpgOrPng && isLt2M;
};
/**
   * upload - Uploads a file to the server
   *
   * @returns {Promise} Resolves with response data on success, or logs error on failure
   */

const StoryTitleComponent = ({
  title = "",
  category = "fables",
  coverImage = "",
  difficulty = 3,
  onChange,
  handleCoverImageChange,
  handleStoryCategoryChange,
  handleStoryDifficultyChange,
}) => {
  const [isTitleEditMode, setTitleEditMode] = useState(false);
  const [storyTitle, setStoryTitle] = useState(title || "Gebe deiner Geschichte einen Titel");
  const [storyCoverImg, setStoryCoverImg] = useState(coverImage);
  const [storyCategory, setStoryCategory] = useState(category);

  const categories = [...Object.keys(STORY_CATEGORIES)];
  const [selectedCat, setSelectedCat] = useState("All");

  //#region Upload Component
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  const [storyDifficulty, setStoryDifficulty] = useState(difficulty);

  React.useEffect(() => {
    setStoryDifficulty(difficulty ?? 3);
  }, [difficulty]);

  const handleChange = async (info) => {
    console.log('info.file.status:::', info.file);
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
        console.log(`Uploading ${info.file.name}`);
        // setStoryCoverImg(url);
      });
      handleCoverImageChange(info.file.response);
      console.log(`Uploaded Response Name::: ${info.file.response}`);
      // setStoryCoverImg(url);
    }
  };

  const upload = async ({ file, onSuccess, onError }) => {

    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.post('/api/upload', formData);
      onSuccess(response.data);
      message.success('Titelbild erfolgreich hochgeladen!');
    } catch (error) {
      const errorMessage = error.response ? `Anfrage abgebrochen wegen Statuscode ${error.response.status}` : 'Unknown error';
      onError(error);
      message.error(errorMessage);
    }

  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      {loading ? (
        <LoadingOutlined style={{ fontSize: 16 }} />
      ) : (
        <PlusOutlined style={{ fontSize: 16 }} />
      )}
      <div
        style={{
          fontSize: 16,
          marginTop: 8,
        }}
      >
        Titelbild hochladen
      </div>
    </button>
  );

  React.useEffect(() => {

    console.log('coverImage:::', coverImage);

    if (title) setStoryTitle(title);
    if (coverImage) setStoryCoverImg(coverImage);
    if (category) setStoryCategory(category);
  }, [title, coverImage, category]);

  //#endregion
  const handleTitleEdit = () => {
    setTitleEditMode(true);
  };

  const handleTitleSave = () => {
    setTitleEditMode(false);
  };
  /**
* Updates title of the story
*
*/
  const handleTitleChange = (newValue) => {
    // const newValue = 'Updated by Child';
    setStoryTitle(newValue);
    onChange(newValue);
  };

  return (

    <Space direction='horizontal' align='center' size="large">

      <Upload

        listType="picture-card"

        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        customRequest={upload}
      >

        {imageUrl ? (
          // If user uploaded a new image in this session, show it
          <img
            src={imageUrl}
            alt="cover"
            style={{
              maxWidth: "200px", // Set maximum width
              maxHeight: "200px", // Set maximum height
              width: "100%", // Optional: make it responsive
              height: "auto", // Maintain aspect ratio

            }} />

        ) : storyCoverImg ? (
          // If editing existing story, show from server
          <StoryImage filename={storyCoverImg} name={storyTitle} style={{
            maxWidth: "200px", // Set maximum width
            maxHeight: "200px", // Set maximum height
            width: "100%", // Optional: make it responsive
            height: "auto", // Maintain aspect ratio

          }} />
        ) : (
          // If no image yet, show upload button
          uploadButton
        )}



      </Upload>

      {isTitleEditMode ? (
        <Input
          onChange={(e) => handleTitleChange(e.target.value)}
          onPressEnter={handleTitleSave}
          onBlur={handleTitleSave} // Save on blur as well to handle when user clicks away
          style={{ width: '100%' }}
          placeholder={storyTitle}
        />
      )
        : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography.Title level={3} style={{ margin: 0 }} onClick={handleTitleEdit}>
              {storyTitle}
            </Typography.Title>
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={handleTitleEdit}
              style={{ marginLeft: 8 }}
            />
          </div>
        )}

      <ConfigProvider
        theme={{
          components: {
            Switch: {
              colorPrimary: streenTheme.colors.secondary,
              colorPrimaryHover: "#008fc891",
            },
            Radio: {
              buttonSolidCheckedBg: streenTheme.colors.secondary,
              colorPrimary: streenTheme.colors.secondary,
              colorPrimaryHover: "#008fc891",
            },
          },
        }}
      >
        <div className="category-filter">
          {categories.map((cat) => {
            const mapped = STORY_CATEGORIES[cat];

            return (
              <Button
                key={cat}
                onClick={(e) => {
                  setStoryCategory(cat);
                  handleStoryCategoryChange(cat);
                  setSelectedCat(cat);
                }}
                className={`btn-category ${selectedCat === cat ? "active" : ""}`}
              >
                {mapped?.emoji || "📖"} {mapped?.label || cat}
              </Button>
            );
          })}
        </div>

        <div className="difficulty-selector">
          <Typography.Text strong>
            Schwierigkeitsgrad
          </Typography.Text>

          <Select
            value={storyDifficulty}
            style={{ width: 190 }}
            onChange={(value) => {
              setStoryDifficulty(value);
              handleStoryDifficultyChange(value);
            }}
            options={[
              { value: 1, label: "1 – Sehr leicht" },
              { value: 2, label: "2 – Leicht" },
              { value: 3, label: "3 – Mittel" },
              { value: 4, label: "4 – Anspruchsvoll" },
              { value: 5, label: "5 – Schwierig" },
            ]}
          />
        </div>

        <Space direction="horizontal" align='baseline' size="large" wrap>
          {/*<Switch checkedChildren="Öffentlich" unCheckedChildren="Nicht öffentlich" defaultChecked /> */}

        </Space>
      </ConfigProvider>
    </Space>


  );

};
export default StoryTitleComponent;